module.exports = __webpack_public_path__ + "img/extermination-bureaux.dfa65396.jpg";